function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Water"
}, /*#__PURE__*/React.createElement("title", null, "VF_water_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 39.6c9.9 10.2 22.6 23.8 35.1 39.3 43.4 53.5 49.9 84.1 49.9 97.6 0 22.7-8.3 42.3-24 56.6s-37.2 22-61 22-45.5-7.8-61-22-24-33.9-24-56.6c0-13.5 6.5-44.1 49.9-97.6 12.5-15.5 25.2-29.2 35.1-39.3m0-39.6S28.3 102.3 28.3 176.5c0 64.2 50.8 107 113.4 107s113.4-42.8 113.4-107C255.1 102.3 141.7 0 141.7 0z"
}))));